// ============================================================================
// recsuit-workflow endpoints — backed by /api/v1/workflow on the server.
// ============================================================================
// The shared axios client's baseURL is '/api' (NOT '/api/v1'), so the
// version prefix '/v1' must be added to every path. Standard recsuit
// pattern uses buildEndpoint() from base.endpoints.ts; the workflow
// folder reads the version prefix directly from apiConfig so it doesn't
// import recsuit-domain endpoint helpers.

import { apiConfig } from 'api/config/apiConfig';

const VERSION_PREFIX = apiConfig.apiVersion ? `/${apiConfig.apiVersion}` : '';
const ROOT = `${VERSION_PREFIX}/workflow`;

export const workflowEndpoints = {
  // Definitions
  listDefinitions: (publishedOnly?: boolean) =>
    publishedOnly ? `${ROOT}/definitions?publishedOnly=true` : `${ROOT}/definitions`,
  getDefinitionFull: (id: string) => `${ROOT}/definitions/${id}`,
  getLatestPublished: (code: string) => `${ROOT}/definitions/by-code/${encodeURIComponent(code)}`,
  createDefinition: () => `${ROOT}/definitions`,
  updateDefinition: (id: string) => `${ROOT}/definitions/${id}`,
  publishDefinition: (id: string) => `${ROOT}/definitions/${id}/publish`,
  deleteDefinition: (id: string) => `${ROOT}/definitions/${id}`,

  // States
  addState: (defId: string) => `${ROOT}/definitions/${defId}/states`,
  updateState: (stateId: string) => `${ROOT}/definitions/states/${stateId}`,
  deleteState: (stateId: string) => `${ROOT}/definitions/states/${stateId}`,

  // Transitions
  addTransition: (defId: string) => `${ROOT}/definitions/${defId}/transitions`,
  updateTransition: (transitionId: string) => `${ROOT}/definitions/transitions/${transitionId}`,
  deleteTransition: (transitionId: string) => `${ROOT}/definitions/transitions/${transitionId}`,

  // Actions
  addAction: (defId: string) => `${ROOT}/definitions/${defId}/actions`,
  deleteAction: (actionId: string) => `${ROOT}/definitions/actions/${actionId}`,

  // Spawn rules
  addSpawnRule: (defId: string) => `${ROOT}/definitions/${defId}/spawn-rules`,
  deleteSpawnRule: (ruleId: string) => `${ROOT}/definitions/spawn-rules/${ruleId}`,

  // Instances
  startInstance: () => `${ROOT}/instances`,
  getInstance: (id: string) => `${ROOT}/instances/${id}`,
  getInstanceByEntity: (entityType: string, entityId: string) =>
    `${ROOT}/instances/by-entity/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}`,
  trigger: (id: string, code: string) =>
    `${ROOT}/instances/${id}/triggers/${encodeURIComponent(code)}`,
  canTrigger: (id: string, code: string) =>
    `${ROOT}/instances/${id}/can-trigger/${encodeURIComponent(code)}`,
  history: (id: string) => `${ROOT}/instances/${id}/history`,

  // Approvals
  approvalInbox: () => `${ROOT}/approvals/inbox`,
  resolveApproval: (id: string) => `${ROOT}/approvals/${id}/resolve`,

  // Chain
  chainTree: (rootInstanceId: string) => `${ROOT}/chain/${rootInstanceId}`,
  descendants: (instanceId: string) => `${ROOT}/chain/${instanceId}/descendants`,
  ancestors: (instanceId: string) => `${ROOT}/chain/${instanceId}/ancestors`,
  link: () => `${ROOT}/chain/link`,
};

export default workflowEndpoints;
